import {Coefficient} from "../domain/coefficient";
import {Pct} from "../domain/pct";
import {EnumCorridorColor} from "../domain/enum-corridor-color";
import {QuoteServicePct} from "../domain/quote-service-pct";
import {CoefficientBoost} from "../domain/coefficient-boost";

export class PctCalculator {


    public calculatePcts(servicesConfPct: QuoteServicePct[], coefficientBoosts: CoefficientBoost[]
    ): Map<string, Pct> {
        const totalCoeff = [...servicesConfPct].reduce((acc, conf) => {
            let coeffOfConsideration = 0;
            if (!!conf?.multiServiceBoost) {
                coeffOfConsideration = conf?.multiServiceBoost?.getCoeffOfConsideration(conf?.quoteServiceMonthlyAmount)
            }
            return acc + coeffOfConsideration
        }, 0);
        const coefficientBoostFounded = coefficientBoosts?.find(coefficientBoost => coefficientBoost?.serviceNumber === Math.ceil(totalCoeff));
        const coefficientBoostWithOneMoreServiceFounded = coefficientBoosts?.find(coefficientBoost => coefficientBoost?.serviceNumber === Math.ceil(totalCoeff + 1));

        const pcts: Map<string, Pct> = new Map(
            [...servicesConfPct].map((conf) => {
                return [conf.serviceCode, new Pct(conf.coefficient,
                    conf?.multiServiceBoost,
                    conf.quoteServiceAppliedPriceColor as EnumCorridorColor,
                    conf.quoteServiceMonthlyAmount,
                    conf.nonNegociableArticlesMonthlyAmount,
                    conf.negociableArticlesMonthlyAmount,
                    conf.quoteServiceContractDuration,
                    conf.cmcUniqueReference,
                    conf.nonNegociableArticleColor,
                    conf.uniqueReferenceCoefficient,
                    coefficientBoostFounded?.boost,
                    coefficientBoostWithOneMoreServiceFounded?.boost,
                    conf.defaultContractDuration)];
            })
        );
        return pcts
    }


}

